var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.icon)?_c('b-tooltip',{attrs:{"label":_vm.label,"position":"is-bottom","type":"is-dark"}},[_c('b-icon',{staticStyle:{"margin-left":"0"},attrs:{"icon":_vm.icon}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }